import type {
  DataPeriodInfo,
  BackfillProgressInfo,
  SourceGroupDataPeriod,
  SourceGroupJobs,
  NexusSdkModelsSyncStatusResponseSyncStatusResponse,
} from "@/backend-sdk/client/types.gen";

type SyncStatusResponse = NexusSdkModelsSyncStatusResponseSyncStatusResponse;

type Listener = (isSyncing: boolean, source?: string | null) => void;
type DetailsListener = (details: SyncDetails) => void;

export interface SyncDetails {
  isSyncing: boolean;
  isInitialSync: boolean; // True apenas durante sincronização inicial curta
  isBackfilling: boolean;
  source: string | null;
  syncPhase: string | null;
  dataPeriod: DataPeriodInfo | null;
  dataPeriodBySource: SourceGroupDataPeriod | null; // Período por grupo (Google/Meta)
  jobsBySource: SourceGroupJobs | null; // Jobs por grupo (Google/Meta)
  backfillProgress: BackfillProgressInfo | null;
}

let isSyncingGlobal = false;
let currentSource: string | null = null;
let currentDetails: SyncDetails = {
  isSyncing: false,
  isInitialSync: false,
  isBackfilling: false,
  source: null,
  syncPhase: null,
  dataPeriod: null,
  dataPeriodBySource: null,
  jobsBySource: null,
  backfillProgress: null,
};
const listeners: Listener[] = [];
const detailsListeners: DetailsListener[] = [];

export function setGlobalSyncStatus(next: boolean, source?: string | null) {
  isSyncingGlobal = next;
  currentSource = source ?? null;
  listeners.forEach((fn) => {
    try {
      fn(isSyncingGlobal, currentSource);
    } catch (error) {
      console.error("Erro ao notificar listener de sincronização:", error);
    }
  });
}

export function setGlobalSyncDetails(status: SyncStatusResponse) {
  currentDetails = {
    isSyncing: status.is_syncing,
    isInitialSync: status.is_initial_sync ?? false,
    isBackfilling: status.is_backfilling ?? false,
    source: status.source ?? null,
    syncPhase: status.sync_phase ?? null,
    dataPeriod: status.data_period ?? null,
    dataPeriodBySource: status.data_period_by_source ?? null,
    jobsBySource: status.jobs_by_source ?? null,
    backfillProgress: status.backfill_progress ?? null,
  };
  detailsListeners.forEach((fn) => {
    try {
      fn(currentDetails);
    } catch (error) {
      console.error(
        "Erro ao notificar listener de detalhes da sincronização:",
        error,
      );
    }
  });
}

function getGlobalSyncStatus() {
  return { isSyncing: isSyncingGlobal, source: currentSource };
}

export function getGlobalSyncDetails(): SyncDetails {
  return currentDetails;
}

function subscribeSyncStatus(listener: Listener) {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx >= 0) listeners.splice(idx, 1);
  };
}

export function subscribeSyncDetails(listener: DetailsListener) {
  detailsListeners.push(listener);
  return () => {
    const idx = detailsListeners.indexOf(listener);
    if (idx >= 0) detailsListeners.splice(idx, 1);
  };
}
